var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8334 7.44448C16.3062 7.44448 17.5001 6.25057 17.5001 4.77781C17.5001 3.30505 16.3062 2.11115 14.8334 2.11115C13.3607 2.11115 12.1667 3.30505 12.1667 4.77781C12.1667 6.25057 13.3607 7.44448 14.8334 7.44448Z",
    stroke: "#ABAFB9",
    strokeWidth: 2.28571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 13.6667C5.63943 13.6667 6.83333 12.4728 6.83333 11C6.83333 9.52727 5.63943 8.33337 4.16667 8.33337C2.69391 8.33337 1.5 9.52727 1.5 11C1.5 12.4728 2.69391 13.6667 4.16667 13.6667Z",
    stroke: "#ABAFB9",
    strokeWidth: 2.28571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8334 19.8889C16.3062 19.8889 17.5001 18.695 17.5001 17.2223C17.5001 15.7495 16.3062 14.5556 14.8334 14.5556C13.3607 14.5556 12.1667 15.7495 12.1667 17.2223C12.1667 18.695 13.3607 19.8889 14.8334 19.8889Z",
    stroke: "#ABAFB9",
    strokeWidth: 2.28571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.46875 12.3423L12.5399 15.88",
    stroke: "#ABAFB9",
    strokeWidth: 2.28571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.531 6.12004L6.46875 9.65782",
    stroke: "#ABAFB9",
    strokeWidth: 2.28571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.bbae90f96b275d36dacd4ea1391cb525.svg";
export { ForwardRef as ReactComponent };